import { PersonBus } from './PersonBus';
import { BaseBus } from './BaseBus';
import { EmployeeBus } from './EmployeeBus';
import { UsersBus } from './UsersBus.model';
import { GItem } from './GItem';
import { EmployHistoryBus } from './EmployHistory';

export class EmployeeBusInputParams extends BaseBus {

    employeeData: EmployeeBus;
    userData: UsersBus;
    userFeatures: GItem[] = [];
    employHistory: EmployHistoryBus[];
}